import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Examranklist.css';

// Fix: Improved standard check to support "XI Commerce", "UG (Undergraduate)", etc.
const isXIOrAbove = (standard) => {
  if (!standard) return false;
  const std = standard.toUpperCase().trim();
  return (
    std.startsWith('XI') ||
    std.startsWith('XII') ||
    std.startsWith('UG') ||
    std.startsWith('PG')
  );
};

const Examranklist = () => {
  const [loading, setLoading] = useState(true);
  const [examDetails, setExamDetails] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [selectedExam, setSelectedExam] = useState(null);
  const [results, setResults] = useState([]);
  const [error, setError] = useState('');
  const [studentstd, setStudentStd] = useState('');

  // Simulate initial load
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleSectionClick = async (section) => {
    const std = section === 'V to X' ? 'VI' : 'XI'; // Use representative class
    setStudentStd(std);
    setSelectedSection(section);

    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API}/questions/examdata?section=${section}`
      );
      setExamDetails(response.data);
    } catch (error) {
      console.error('Error fetching exam data:', error);
      setExamDetails([]);
    } finally {
      setLoading(false);
    }
  };

  const handleExamClick = async (examid, examTitle) => {
    try {
      setLoading(true);
      setResults([]);
      setError('');

      const onlinePromise = axios.get(
        `${process.env.REACT_APP_API}/questions/exam-results/${examid}`
      );

      let resultsData = [];
      if (examid === 1) {
        const [offlineRes, onlineRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API}/questions/offline-exam-results`),
          onlinePromise,
        ]);
        resultsData = [...offlineRes.data, ...onlineRes.data];
      } else {
        const onlineRes = await onlinePromise;
        resultsData = onlineRes.data;
      }

      const filtered = resultsData.filter((r) =>
        isXIOrAbove(studentstd)
          ? isXIOrAbove(r.standard)
          : !isXIOrAbove(r.standard)
      );

      const sorted = filtered.sort((a, b) => b.total_correct - a.total_correct);
      
      setSelectedExam({ id: examid, title: examTitle });
      setResults(sorted);
      // console.log('lalllla',sorted)
    } catch (err) {
      console.error('Error fetching results:', err);
      setError('❌ Error fetching exam results.');
    } finally {
      setLoading(false);
    }
  };

  const closeExamModal = () => {
    setSelectedSection(null);
    setExamDetails(null);
  };

  const closeResultsModal = () => {
    setSelectedExam(null);
    setResults([]);
    setError('');
  };

  return (
    <div className="examrank-container">
      <h2 className="examrank-title">Exam Rank List</h2>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <div className="examrank-section" onClick={() => handleSectionClick('V to X')}>
            <h4 className="examrank-header">V to X</h4>
          </div>
          <div className="examrank-section" onClick={() => handleSectionClick('XI to PG')}>
            <h4 className="examrank-header">XI to PG</h4>
          </div>
        </>
      )}

      {/* Modal 1: Exam List */}
      {selectedSection && examDetails && (
        <div className="examrank-modal">
          <div className="examrank-modal-content" style={{maxWidth:'500px'}}>
            <span className="examrank-modal-close" onClick={closeExamModal}>
              &times;
            </span>
            <h3 className="examrank-modal-header">{selectedSection} Exams</h3>

            {examDetails.length > 0 ? (
              <ul className="examrank-list">
                {examDetails.map((examtype, index) => {
                  const rankClass = index % 2 === 1 ? 'gold' : 'silver';
                  return (
                    <li
                      key={examtype.id}
                      className={rankClass}
                      onClick={() => handleExamClick(examtype.id, examtype.title)}
                    >
                      <strong>{index + 1}. {examtype.title}</strong>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <p>No exams available.</p>
            )}
          </div>
        </div>
      )}

      {/* Modal 2: Rank List */}
    {selectedExam && (
  <div className="examrank-modal">
    <div className="examrank-modal-content">
      <span className="examrank-modal-close" onClick={closeResultsModal}>
        &times;
      </span>
      <h3 className="examrank-modal-header">Rank List: {selectedExam.title}</h3>

      {loading ? (
        <p>Loading results...</p>
      ) : error ? (
        <p className="error">{error}</p>
      ) : results.length > 0 ? (
        <div className="table-wrapper">
          <table className="examrank-table">
            <thead>
              <tr>
                <th>Rank</th>
                <th>Name</th>
                <th>Father's Name</th>
                <th>Standard</th>
                <th>Total Correct</th>
                <th>Total Questions</th>
                <th>Time Taken</th>
              </tr>
            </thead>
            <tbody>
              {results.map((r, idx) => (
                <tr key={r.student_id || idx}>
                  <td>{idx + 1}</td>
                  <td>{r.name}</td>
                  <td>{r.father_name || '-'}</td>
                  <td>{r.standard}</td>
                  <td>{r.total_correct}</td>
                  <td>{r.total_questions}</td>
                  <td>{r.total_time_taken || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>No results available.</p>
      )}
    </div>
  </div>
)}

    </div>
  );
};

export default Examranklist;
